const FilterType = Object.freeze({
  NONE: "None",
  HORIZONTAL: "Horizontal",
  SIDEBAR: "Sidebar",
});

export default FilterType;
